(() => {
  'use strict';
  const publicHost = host => /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z][a-z0-9-]*[a-z0-9]$/i.test(host)
    && !/(?:^|\.)(?:localhost|local|internal|test|invalid|example|lan|home|onion|arpa)$|(?:^|\.)(?:example\.(?:com|net|org)|nip\.io|sslip\.io|localtest\.me|lvh\.me)$/i.test(host);
  function safePublic(value, hosts, image = false) {
    if (typeof value !== 'string' || value !== value.trim() || /[\s<>\\]|__BK_|BINDING_REQUIRED|ROUTE_REQUIRED/i.test(value)) return null;
    try {
      const u = new URL(value);
      if (u.protocol !== 'https:' || u.username || u.password || u.port || u.hash || !publicHost(u.hostname) || !Array.isArray(hosts) || !hosts.some(host => typeof host === 'string' && host.toLowerCase() === u.hostname)) return null;
      if (!image && u.search) return null;
      if (image && [...u.searchParams].some(([k,v]) => !['v','width','height','crop','format'].includes(k) || !/^[a-z0-9._-]+$/i.test(v))) return null;
      return u.href;
    } catch { return null; }
  }
  function setup(group) {
    if (group.dataset.schoolShareInitialised) return;
    group.dataset.schoolShareInitialised = 'true';
    let dictionary = {};
    try { dictionary = JSON.parse(group.closest('.bk-school').querySelector('[data-school-i18n]')?.textContent || '{}'); } catch {}
    const t = source => dictionary[source] || source;
    const input = group.querySelector('[data-school-share-address]');
    const status = group.querySelector('[data-school-share-status]');
    const copy = group.querySelector('[data-school-share-copy]');
    const device = group.querySelector('[data-school-share-device]');
    const fileButton = group.querySelector('[data-school-share-file]');
    if (!input || !status || !copy || !device) return;
    let pageHosts = [], imageHosts = [];
    try { pageHosts = JSON.parse(group.dataset.schoolSharePageHosts || '[]'); imageHosts = JSON.parse(group.dataset.schoolShareImageHosts || '[]'); } catch {}
    const url = safePublic(group.dataset.schoolShareUrl, pageHosts);
    const image = safePublic(group.dataset.schoolShareImage, imageHosts, true);
    const previewQuery = /(?:^|&)(?:preview_theme_id|preview|pb|_fd)=/i.test(window.location.search.slice(1));
    const ready = group.dataset.schoolShareMode === 'public' && url && image && window.location.protocol === 'https:' && new URL(url).hostname === window.location.hostname && !previewQuery;
    const say = message => { status.textContent = message; };
    const locationURL = new URL(window.location.href); locationURL.hash = ''; locationURL.search = '';
    input.value = ready ? url : locationURL.href;
    copy.disabled = false;
    if (!ready) {
      group.dataset.schoolShareMode = 'review';
      const notice = group.querySelector('[data-school-share-notice]');
      if (notice) notice.textContent = t('Local English review. Platform sharing needs a verified public page and image. You can copy this review address.');
      group.querySelectorAll('[data-school-share-channel]').forEach(control => {
        control.removeAttribute('href'); control.removeAttribute('target'); control.setAttribute('aria-disabled', 'true');
        if (control.tagName === 'BUTTON') control.disabled = true;
        else { control.setAttribute('role', 'link'); control.tabIndex = -1; }
      });
      copy.querySelector('span:last-child').textContent = t(group.classList.contains('sc-header-share') ? 'Copy local review link' : 'Copy review link');
    }
    input.addEventListener('click', () => input.select());
    copy.addEventListener('click', async () => {
      try {
        if (!window.isSecureContext || !navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(input.value);
        say(t(ready ? 'Link copied.' : 'Local review link copied. It works only where this review is available.'));
      } catch {
        input.focus(); input.select(); input.setSelectionRange(0, input.value.length);
        say(t('Select and copy the link shown above. Automatic copying is not available in this browser.'));
      }
    });
    const shareData = {title:group.dataset.schoolShareTitle || t('Solid Cosmetics School'), text:group.dataset.schoolShareDescription || '', url};
    let linkSupported = false;
    if (ready && window.isSecureContext && typeof navigator.share === 'function') {
      try { linkSupported = typeof navigator.canShare !== 'function' || navigator.canShare(shareData); } catch {}
    }
    device.disabled = !linkSupported;
    device.addEventListener('click', async () => {
      if (!ready || !linkSupported) return;
      device.disabled = true;
      try { await navigator.share(shareData); say(t('Your device has handled the share request.')); }
      catch (error) { say(t(error?.name === 'AbortError' ? 'Sharing cancelled.' : 'Your device could not open sharing. Copy the link or choose a service instead.')); }
      finally { device.disabled = false; }
    });
    group.querySelectorAll('[data-school-share-download]').forEach(anchor => anchor.addEventListener('click', async event => {
      if (!ready) return;
      const source = safePublic(anchor.href, imageHosts, true);
      if (!source) return;
      event.preventDefault();
      try {
        const response = await fetch(source, {credentials:'omit', mode:'cors', redirect:'error'});
        if (!response.ok) throw new Error('Image unavailable');
        const blob = await response.blob();
        if (!/^image\/(?:png|jpeg|webp)$/.test(blob.type) || !blob.size) throw new Error('Image unavailable');
        const download = document.createElement('a');
        const objectURL = URL.createObjectURL(blob);
        download.href = objectURL;
        download.download = anchor.getAttribute('download') || 'school-sharing-image.png';
        document.body.append(download); download.click(); download.remove();
        setTimeout(() => URL.revokeObjectURL(objectURL), 1000);
      } catch {
        window.open(source, '_blank', 'noopener,noreferrer');
      }
    }));
    let preparedFile = null, preparing = false;
    async function prepareFile() {
      if (preparedFile || preparing || !fileButton || !window.isSecureContext || typeof navigator.share !== 'function' || typeof navigator.canShare !== 'function' || typeof File !== 'function') return;
      preparing = true;
      try {
        const anchor = group.querySelector('[data-school-share-download]');
        const src = new URL(anchor.getAttribute('href'), location.href);
        const local = src.origin === location.origin && /^https?:$/.test(src.protocol);
        const bound = ready && safePublic(src.href, imageHosts, true);
        if ((!local && !bound) || !/\.(?:png|jpe?g|webp)$/i.test(src.pathname)) return;
        const response = await fetch(src.href, {credentials:local ? 'same-origin' : 'omit', mode:local ? 'same-origin' : 'cors', redirect:'error'});
        if (!response.ok) return;
        const blob = await response.blob();
        if (!/^image\/(?:png|jpeg|webp)$/.test(blob.type) || !blob.size) return;
        const ext = blob.type === 'image/png' ? 'png' : blob.type === 'image/jpeg' ? 'jpg' : 'webp';
        const file = new File([blob], `school-${document.documentElement.lang}-${group.closest('.bk-school').dataset.schoolPage || 'lesson'}.${ext}`, {type:blob.type});
        if (navigator.canShare({files:[file]})) { preparedFile = file; fileButton.hidden = false; }
      } catch { /* Native download remains usable. */ }
      finally { preparing = false; }
    }
    fileButton?.addEventListener('click', async () => {
      if (!preparedFile) return;
      fileButton.disabled = true;
      try { await navigator.share({files:[preparedFile], title:shareData.title}); say(t('Your device has handled the image share request.')); }
      catch (error) { say(t(error?.name === 'AbortError' ? 'Sharing cancelled.' : 'Your device could not share the image. Download it and attach it yourself instead.')); }
      finally { fileButton.disabled = false; }
    });
    if (group.tagName === 'DETAILS') {
      const summary = group.querySelector('summary');
      const close = group.querySelector('[data-school-share-close]');
      close.hidden = false;
      const shut = () => { group.open = false; summary.focus({preventScroll:true}); };
      close.addEventListener('click', shut);
      group.addEventListener('keydown', event => { if (event.key === 'Escape' && group.open) { event.preventDefault(); shut(); } });
      document.addEventListener('click', event => { if (group.open && !group.contains(event.target)) group.open = false; });
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        prepareFile();
        const panel = group.querySelector('.sc-header-share-panel');
        requestAnimationFrame(() => {
          const top = panel.getBoundingClientRect().top;
          const clearance = Math.max(110, parseFloat(getComputedStyle(group.closest('.bk-school')).getPropertyValue('--school-header-offset')) || 0);
          if (window.innerHeight - top < 260) window.scrollBy({top:Math.max(0,top-clearance),behavior:'instant'});
          panel.style.maxHeight = Math.max(240, window.innerHeight-panel.getBoundingClientRect().top-16)+'px';
        });
      });
    }
  }
  const init = () => document.querySelectorAll('[data-school-share]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
